import styled, { css } from 'styled-components';
import { Text } from '@lmn/design-system';
import { ellipsis } from '@/app/components/search/styles/mixins.ts';

/** The two card systems space the line differently; everything else is shared. */
export type CertificationVariant = 'card' | 'evoCard';

export const CertificationContainer = styled.div<{ $isOverlay: boolean; $variant: CertificationVariant }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  max-width: 100%;

  ${({ $variant, $isOverlay }) =>
    $variant === 'card'
      ? css`
          margin-bottom: ${$isOverlay ? '4px' : '8px'};
        `
      : css`
          margin-bottom: 12px;

          ${
            !$isOverlay &&
            css`
              @media (min-width: 768px) {
                margin-bottom: 16px;
              }
            `
          }
        `}

  img {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
  }
`;

export const CertificationLabel = styled(Text)`
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  ${ellipsis};
`;
